import { useQueryGtfsResourceById, useQueryGtfsSegment, useQueryGtfsSegmentShape } from "../../Queries";
import { useContext, useState, useEffect, useId } from "react";
import { ToolsContext } from "../../ToolsContext";
import { RLayer, RPopup, RSource, useMap } from "maplibre-react-components";
import { LngLatBounds } from "maplibre-gl"
import React from "react";

export function SegmentsMl() {
    const tool = useContext(ToolsContext);
    const GTrip = tool.selection;
    const { data: segment, isPendingS, errorS } = useQueryGtfsSegment(
        (tool.selection) ? tool.selection.route_type : 3,
        (tool.selection) ? tool.selection.from_stop_id : null,
        (tool.selection) ? tool.selection.to_stop_id : null
    );
    const {isPending: shapeIsPending, error: shapeError, data: shapeData} = useQueryGtfsSegmentShape(
        tool.selection.route_type,
        tool.selection.from_stop_id,
        tool.selection.to_stop_id
    );
    const id = useId();
    const map = useMap("map-ml");
  
    const Layers = [];

    useEffect(() => {

        /** trochę skomplikowana procedura dostosowywania mapy do 
         * kształtu segmentuj na mapie, zaczerpnięta
         * z przykładu w dokumentacji maplibre: 
         * 
         * https://maplibre.org/maplibre-gl-js/docs/examples/zoomto-linestring/
         * 
         * */ 
        if (!shapeData) return;
        const coordinates = shapeData;

        const bounds = coordinates.reduce((bounds, coord) => {
            return bounds.extend(coord);
        }, new LngLatBounds(coordinates[0], coordinates[0]));

        map.fitBounds(bounds, {
            padding: 20
        });
    },[tool.selection,shapeData]);


    if (shapeIsPending || shapeError || !shapeData 
        || isPendingS || errorS || !segment
    )
        return;

    const layout = {
        'line-cap': 'round',
        'line-join': 'round',
    }

    const paint = { 
        'line-color': '#0000ff',
        'line-width': 4,
        //'line-opacity': 0.55
    };

    /** Kształt trasy kursu */

    Layers.push(
        <>
            <RSource
                id={'S' + GTrip.trip_id}
                type="geojson"
                data={
                    {
                        "type": "FeatureCollection",
                        "features": [
                            {
                                "type": "Feature",
                                "geometry": {
                                    "coordinates": [...shapeData],
                                    "type": "LineString"
                                }
                            }
                        ]
                    }
                }
            />
            <RLayer
                source={'S' + GTrip.trip_id }
                id={'L' + GTrip.trip_id }
                type="line"
                paint={paint}
                layout={layout}
            />
        </>
    )

    return (
        <>
            {Layers}
        </>
    )
}